/* eslint-disable no-script-url */
import { useEffect, useState } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { HeaderWrapper } from "../styles/StyledComponents/HeaderWrapper";
import assests from "../ui/assests";
import ArrowIcon from "../ui/icons/ArrowIcon";
import ContactIcon from "../ui/icons/ContactIcon";
import MenuIcon from "../ui/icons/MenuIcon";
import { navMenu } from "../ui/json/routes.mock";
import { HeaderDrawer } from "./HeaderDrawer";

const Header = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const pathname = location.pathname;
  const [mobileOpen, setMobileOpen] = useState(false);
  const [scrollClass, setScrollClass] = useState("");

  useEffect(() => {
    let lastScrollY = 0;

    const updateScrollClass = () => {
      const currentScrollY = window.scrollY;

      if (currentScrollY <= 10) {
        setScrollClass("");
      } else if (currentScrollY > lastScrollY) {
        setScrollClass("scroll_down");
      } else if (currentScrollY < lastScrollY) {
        setScrollClass("scroll_up");
      }

      lastScrollY = currentScrollY;
    };

    // Delay to allow layout/render to settle
    const timeoutId = setTimeout(() => {
      lastScrollY = window.scrollY;
      updateScrollClass();
    }, 100); // You can try increasing to 200ms if needed

    window.addEventListener("scroll", updateScrollClass);
    return () => {
      window.removeEventListener("scroll", updateScrollClass);
      clearTimeout(timeoutId);
    };
  }, []);

  useEffect(() => {
    const body = document.body;
    if (mobileOpen) {
      body.classList.add("drawer_open");
    } else {
      body.classList.remove("drawer_open");
    }
    body.style.overflow = mobileOpen ? "hidden" : "auto";

    return () => {
      body.classList.remove("drawer_open");
      body.style.overflow = "auto";
    };
  }, [mobileOpen]);

  const handleDrawerToggle = () => {
    setMobileOpen(!mobileOpen);
  };

  return (
    <HeaderWrapper>
      <header
        className={`headerWrapper ${scrollClass || "scroll_up"} ${mobileOpen ? "drawerOpen" : ""}`}
      >
        <nav>
          <div className="container">
            <div className="headerWrapper_inner">
              <Link to="/" className="headerLogo">
                <img src={assests.logo} alt="logoImg" />
              </Link>
              <ul className="header_menu_list">
                {navMenu?.map((data, index) => (
                  <li
                    key={index}
                    className={pathname === data.route ? "active" : ""}
                  >
                    <Link to={data?.route}>
                      {data?.list}
                      {data?.subMenuList.length > 0 ? (
                        <i>
                          <ArrowIcon />
                        </i>
                      ) : (
                        ""
                      )}
                    </Link>
                    <ul className="submenuUl">
                      {data?.subMenuList?.map((item, subIndex) => (
                        <li key={subIndex}>
                          <Link to={item?.route}>{item?.list}</Link>
                        </li>
                      ))}
                    </ul>
                  </li>
                ))}
              </ul>
              <div className="header_rht_Wrap">
                <button
                  className="contact_btn"
                  onClick={() => {
                    navigate("/contact-us");
                  }}
                >
                  <ContactIcon /> CONTACT US
                </button>
                <button className="menuIconbtn" onClick={handleDrawerToggle}>
                  <MenuIcon />
                </button>
              </div>
            </div>
          </div>
          {mobileOpen && (
            <>
              <div className="overlay" />
              <HeaderDrawer closeDrawer={handleDrawerToggle} />
            </>
          )}
        </nav>
      </header>
    </HeaderWrapper>
  );
};

export default Header;
